import { render } from "./PowerUpsPanelSimplified.vue?vue&type=template&id=327f5fdd&scoped=true"
import script from "./PowerUpsPanelSimplified.vue?vue&type=script&lang=js"
export * from "./PowerUpsPanelSimplified.vue?vue&type=script&lang=js"

import "./PowerUpsPanelSimplified.vue?vue&type=style&index=0&id=327f5fdd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327f5fdd"]])

export default __exports__